module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.enterPreloader,
      "leave": _vm.leavePreloader
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }],
    staticClass: "loader__inner"
  }, [_c('img', {
    ref: "cloud1",
    staticClass: "cloud cloud--1",
    attrs: {
      "src": _vm.urlCloud1,
      "width": "200",
      "height": "108",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    ref: "cloud2",
    staticClass: "cloud cloud--2",
    attrs: {
      "src": _vm.urlCloud2,
      "width": "200",
      "height": "76",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "fly",
    attrs: {
      "id": "fly"
    }
  }), _vm._v(" "), _c('div', {
    ref: "loadingbar",
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      width: _vm.width
    })
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53b4ed49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/website/Loader.vue
// module id = 706
// module chunks = 64